import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5002';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000 // 60s for AI inference
});

export async function uploadImageForInspection(file, mode) {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('mode', mode);

  const response = await api.post('/api/inspect', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
}

export async function getInspections(limit = 20, mode = null) {
  const params = { limit };
  if (mode) params.mode = mode;
  const response = await api.get('/api/inspect', { params });
  return response.data;
}

export async function getInspection(id) {
  const response = await api.get(`/api/inspect/${id}`);
  return response.data;
}

export async function getStats() {
  const response = await api.get('/api/inspect/stats/overview');
  return response.data;
}

export async function exportReport(id) {
  const response = await api.get(`/api/inspect/${id}/export`);
  return response.data;
}

export async function uploadVideoForInspection(file, mode, interval = 1, onProgress) {
  const formData = new FormData();
  formData.append('video', file);
  formData.append('mode', mode);
  formData.append('interval', interval);

  const response = await api.post('/api/inspect/video', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000, // 5 min for video processing
    onUploadProgress: onProgress
  });
  return response.data;
}

export async function analyzeWebcamFrame(imageBase64, mode) {
  const response = await api.post('/api/inspect/frame', { imageBase64, mode }, {
    timeout: 15000
  });
  return response.data;
}

export function getImageUrl(path) {
  return `${API_BASE}${path}`;
}

export default api;
